import React, { useEffect, useState } from "react";
import FloatingContactOptionsComponent from "@/components/overlay/FloatingContactOptions";
import { properties } from "@/components/overlay/ContactData";
import { isNotUndefined } from "@/shared/FunctionCore";

const Contact = ({
  countryCode,
  isEmailDisplay,
  isPhoneDisplay,
}): JSX.Element => {
  const [phoneEmailData, setPhoneEmailData] = useState<any>();

  useEffect(() => {
    const getContactDataBasedOnCountry = () => {
      const phoneEmailDataTemp = properties?.[countryCode];
      if(isNotUndefined(phoneEmailDataTemp)) {
        phoneEmailDataTemp["isEmailDisplay"] = isEmailDisplay;
        phoneEmailDataTemp["isPhoneDisplay"] = isPhoneDisplay;
        setPhoneEmailData(phoneEmailDataTemp);
      }
    };
    getContactDataBasedOnCountry();
  }, [countryCode, isEmailDisplay]);

  return (
    <>
      {phoneEmailData && (
        <FloatingContactOptionsComponent properties={phoneEmailData} />
      )}
    </>
  );
};

export default Contact;
